import  { useState } from 'react';
import { InputGroup, Input, InputGroupAddon, InputGroupText, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import moment from 'moment';
import { useUserPendingHistory } from '../api/upgradeApi';
import { useParams } from 'react-router-dom';
import { useDebounce } from '../../../hook/debounce';
import Loader from '../../Loader/buttonLoad';

const PendingDetails = () => {
    const { id } = useParams()



    const [search, setSearch] = useState('')

    const searchText = useDebounce(search)

    const [page, setPage] = useState(1);

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const { data: pendingData, isLoading: pendingLoading } = useUserPendingHistory({
        level: id - 1, page,
        size: rowsPerPage,
        searchText
    })





    const totalPages = Math.ceil(pendingData?.total / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {  // Ensure newPage is within valid range
            const currentScrollY = window.scrollY;
            setPage(newPage); // Update the page number
            window.requestAnimationFrame(() => {
                window.scrollTo(0, currentScrollY); // Scroll to the previous position
            });
        }
    };

    return (
        <div>
            {pendingLoading && <Loader />}
            <div className="px-4 mb-3">
                <div className='row justify-content-between'>
                    <div className="col-md-6 mb-2 mb-md-0 text-center text-md-left">
                        <div className='d-inline-flex g-8 align-items-center'>
                            <span className='fs-18 fw-400 text-white-60'>Show</span>
                            <div className='form-group mb-0 formInputs gradientBg'>
                                <select className='form-control' onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setPage(1);
                                }}>
                                    <option value="10">10</option>
                                    <option value="30">30</option>
                                    <option value="50">50</option>
                                </select>
                            </div>
                            <span className='fs-18 fw-400 text-white-60'>entries</span>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-inline justify-content-md-end justify-content-center'>
                            <div className="formInputs form-group gradientBg">
                                <InputGroup>
                                    <InputGroupAddon addonType="prepend" tag='div'>
                                        <InputGroupText className='pl-0'>
                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M2.25 7.5C2.25 8.18944 2.3858 8.87213 2.64963 9.50909C2.91347 10.146 3.30018 10.7248 3.78769 11.2123C4.2752 11.6998 4.85395 12.0865 5.49091 12.3504C6.12787 12.6142 6.81056 12.75 7.5 12.75C8.18944 12.75 8.87213 12.6142 9.50909 12.3504C10.146 12.0865 10.7248 11.6998 11.2123 11.2123C11.6998 10.7248 12.0865 10.146 12.3504 9.50909C12.6142 8.87213 12.75 8.18944 12.75 7.5C12.75 6.81056 12.6142 6.12787 12.3504 5.49091C12.0865 4.85395 11.6998 4.2752 11.2123 3.78769C10.7248 3.30018 10.146 2.91347 9.50909 2.64963C8.87213 2.3858 8.18944 2.25 7.5 2.25C6.81056 2.25 6.12787 2.3858 5.49091 2.64963C4.85395 2.91347 4.2752 3.30018 3.78769 3.78769C3.30018 4.2752 2.91347 4.85395 2.64963 5.49091C2.3858 6.12787 2.25 6.81056 2.25 7.5Z" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15.75 15.75L11.25 11.25" stroke="white" strokeOpacity="0.6" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input type='text' placeholder='Search' value={search} onChange={(e) => setSearch(e.target.value)} />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='table-responsive mb-3'>
                <table className='table myapptable table-hover table-borderless mb-0'>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>User ID</th>
                            <th>Name</th>
                            <th >Date & Time</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            pendingData?.result?.length > 0 ? (
                                pendingData?.result.map((v, i) => (

                                    <tr key={v.userId}> 
                                        <td>{(page - 1) * rowsPerPage + (i + 1)}</td>

                                        <td>{v?.downlines?.userId || "--"}</td> 
                                        <td>{v?.downlines?.username || "--"}</td> 
                                        <td className='pr-4 text-nowrap'>
                                            <span>{moment(v?.downlines?.createdAt).format("DD/MM/YYYY | hh:mm A")}</span> 
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No data found</td>
                                </tr>
                            )
                        }


                    </tbody>
                </table>
            </div>
            <div className="px-4">
                <div className='row'>

                    <div className='col-lg-12'>
                        <Pagination aria-label="Page navigation" className="customPagination">
                            {/* Previous Button */}
                            <PaginationItem disabled={page === 1}>
                                <PaginationLink
                                    previous
                                    href="#"
                                    onClick={() => handlePageChange(page - 1)}
                                    className="prevbtn"
                                >
                                    <i className="bi bi-arrow-left align-bottom"></i> Previous
                                </PaginationLink>
                            </PaginationItem>

                            {/* Pagination Numbers */}
                            <span className="number">
                                {Array.from({ length: totalPages }, (_, index) => (
                                    <PaginationItem key={index} active={index + 1 === page}>
                                        <PaginationLink
                                            href="#"
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </PaginationLink>
                                    </PaginationItem>
                                ))}
                            </span>

                            {/* Next Button */}
                            <PaginationItem disabled={page === totalPages}>
                                <PaginationLink
                                    next
                                    href="#"
                                    onClick={() => handlePageChange(page + 1)}
                                    className="nextbtn"
                                >
                                    Next <i className="bi bi-arrow-right align-bottom"></i>
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PendingDetails;